import { makeAssistantToolUI } from "@assistant-ui/react";
import { TableDisplay } from "./TableDisplay";
import type { TableDisplayData } from "@acto/taskpane/core/chat";

interface TableToolArgs {
  title: string;
  description?: string;
}

interface TableToolResult {
  data: Record<string, string | number | null>[];
}

export const TableToolUI = makeAssistantToolUI<TableToolArgs, TableToolResult>({
  toolName: "display_table",
  render: ({ args, result }) => {
    if (!result) return null;

    const tableData: TableDisplayData = {
      title: args.title,
      description: args.description,
      data: result.data,
    };

    return <TableDisplay data={tableData} />;
  },
});
